import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BuildAndroidCard from '../../components/BuildAndroidCard/BuildAndroidCard';
import { StatusEnum } from '../../utils/enumerators/Status.enum';
import { getGitlabJobs, getTags, validateToken } from '../../utils/services/gitlab-service';
import PageDefault from '../PageDefault/PageDefault';

import { getGitLabTokens } from '../../utils/services/service';

import './DashboardAndroid.scss';

function DashboardAndroid() {
	const history = useNavigate();

	const [status, setStatus] = useState(StatusEnum.LOADING);

	const [jobs, setJobs] = useState([]);

	const myTimer = useRef(null);

	async function getDashboard(refreshed) {
		const getJobs = () => {
			getGitlabJobs()
				.then(async (jobs) => {
					setJobs(jobs);
					setStatus(StatusEnum.SUCCESS);
				})
				.catch(() => {
					validateToken((tokenValid) => {
						if (tokenValid) {
							getDashboard(true);
						} else {
							setStatus(StatusEnum.ERROR);
							setJobs([]);

							history('/login');
						}
					});
				});
		};

		if (refreshed) {
			getJobs();
		} else {
			getGitLabTokens()
				.then(() => {
					getTags()
						.then(() => {
							getJobs();
						})
						.catch(() => {
							setStatus(StatusEnum.ERROR);
							setJobs([]);
						});
				})
				.catch(() => {
					setStatus(StatusEnum.ERROR);
				});
		}
	}

	useEffect(() => {
		getDashboard(false);
	}, []);

	const startTimer = () => {
		myTimer.current = setInterval(() => {
			if (document.location.pathname == '/dashboard-android' && status == StatusEnum.SUCCESS && jobs.length > 0) {
				getDashboard(true);
			}
		}, 10 * 1000);
	};

	useEffect(() => {
		startTimer();
		return () => myTimer.current != null && clearInterval(myTimer.current);
	}, [status]);
	return (
		<PageDefault>
			<div className="dashboard-android">
				{status == StatusEnum.LOADING && <span className="message centered">Carregando Dashboard...</span>}

				{status == StatusEnum.SUCCESS && jobs.length > 0 && (
					<>
						<div className="header-top">Últimas Builds Android</div>
						<div className="builds-container">
							{jobs.map((job, index) => (
								<BuildAndroidCard
									key={`job_${index}`}
									job={job}
								/>
							))}
						</div>
					</>
				)}
			</div>
		</PageDefault>
	);
}

export default DashboardAndroid;
